'use strict';

const startsWith = (baseString, searchedString) => baseString.indexOf(searchedString, 0) === 0;
module.exports = startsWith;
